/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 29.04.2016.
 */

import React, {Component, PropTypes} from 'react';

import Translate from '../../../../Translate';

class Ratings extends Component {
  constructor(props) {
    super (props);

    this.state = {};
  }

  _renderRating(rating) {

    switch (rating.type) {
      case 'imdb':
        return (
          <div className="rating mr-" title="IMDb" key={'rating_' + rating.type}>
            <i className="color-grey rating-logo ic ic-imdb mr-"></i>
            <span className="rating-value ph-">{rating.avg_value} <Translate content="profile.ratings.rating_delimiter" /> 10</span>
          </div>
        );
      case 'metascore':
        return (
          <div className="rating mr-" title="Metascore" key={'rating_' + rating.type}>
            <i className="color-grey rating-logo ic ic-metascore"></i>
            <span className="rating-value ph-">{rating.avg_value} <Translate content="profile.ratings.rating_delimiter" /> 100</span>
          </div>
        );
      case 'mpaa':
        switch (rating.avg_value) {
          case 0:
            return (
              <div className="rating mr-" title="MPAA G" key={'rating_' + rating.type}>
              <i className="color-grey rating-logo ic ic-mpaa-g mr-"></i>
            </div>
            );

         case 1:
            return (
              <div className="rating mr-" title="MPAA PG" key={'rating_' + rating.type}>
                <i className="color-grey rating-logo ic ic-mpaa-pg mr-"></i>
              </div>
            );

         case 2:
            return (
              <div className="rating mr-" title="MPAA PG-13" key={'rating_' + rating.type}>
                <i className="color-grey rating-logo ic ic-mpaa-pg-13 mr-"></i>
              </div>
            );

         case 3:
            return (
              <div className="rating mr-" title="MPAA R" key={'rating_' + rating.type}>
                <i className="color-grey rating-logo ic ic-mpaa-r mr-"></i>
              </div>
            );

         case 4:
            return (
              <div className="rating mr-" title="MPAA NC-17" key={'rating_' + rating.type}>
                <i className="color-grey rating-logo ic ic-mpaa-nc-17 mr-"></i>
              </div>
            );
        }

      default:
        return <no-rating key={'rating_' + rating.type}></no-rating>;
    }
  }

  render() {

    return (
      <div className="profile-global-ratings">
          {this.props.ratings.map(this._renderRating)}
      </div>
    );
  }
}

Ratings.propTypes = {
  ratings: PropTypes.array
};

Ratings.defaultProps = {
  ratings: []
};

export default Ratings;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/Ratings/ratings.js